import MouseFollower from 'mouse-follower';
import gsap from 'gsap';
import { getOffset } from '../utils/dom.utils';
import { isTouchDevice } from '../utils/base.utils';
import { Tween } from 'gsap/gsap-core';
import Swiper from 'swiper';

MouseFollower.registerGSAP(gsap);

const cursor = !isTouchDevice() ? new MouseFollower({
  speed: 1.1,
  stickDelta: 0,
  stateDetection: {
    '-pointer': 'a,button',
    '-icon-only': '.btn-icon-only',
    '-burger': '.burger',
  },
}) : null;

if (cursor) {
  console.log('Cursor initialized:', cursor);
} else {
  console.log('Cursor not initialized, running on a touch device.');
}

const stickyWrapList = document.querySelectorAll('[data-sticky-wrap]');

if (!isTouchDevice())
  stickyWrapList.forEach((stickyWrap) => {
    const stickyTarget = stickyWrap.querySelector('[data-sticky-target]');

    stickyWrap.addEventListener('mousemove', (e) => {
      const { top: offsetTop, left: offsetLeft } = getOffset(stickyWrap);

      const x = e.pageX - offsetLeft - stickyWrap.clientWidth / 2;
      const y = e.pageY - offsetTop - stickyWrap.clientHeight / 2;

      const xPosition =
        ((x - stickyWrap.clientWidth / 2) / stickyWrap.clientWidth) * 10;
      const yPosition =
        ((y - stickyWrap.clientHeight / 2) / stickyWrap.clientHeight) * 10;

      gsap.to(stickyWrap, {
        scale: 2,
        ease: 'power2.out',
      });
      gsap.to(stickyTarget, {
        x: xPosition,
        y: yPosition,
        scale: 0.5,
        ease: 'power2.out',
      });

      cursor?.el.style.setProperty('--x-offset', `${xPosition}px`);
      cursor?.el.style.setProperty('--y-offset', `${yPosition}px`);
    });

    stickyWrap.addEventListener('mouseleave', () => {
      gsap.to(stickyWrap, {
        scale: 1,
        ease: 'power2.out',
      });

      gsap.to(stickyTarget, {
        x: 0,
        y: 0,
        scale: 1,
        ease: 'power2.out',
      });

      cursor?.el.style.setProperty('--x-offset', `0px`);
      cursor?.el.style.setProperty('--y-offset', `0px`);
    });
  });

const iconBtnList = document.querySelectorAll('.btn-icon');

iconBtnList.forEach((btn) => {
  btn.addEventListener('mouseenter', () => {
    const target = btn.querySelector('.btn-icon__icon-wrap');
    cursor?.setStick(target);
  });

  btn.addEventListener('mouseleave', () => {
    cursor?.removeStick();
  });
});

const iconOnlyBtnList = document.querySelectorAll('.btn-icon-only');

iconOnlyBtnList.forEach((btn) => {
  btn.addEventListener('mouseenter', () => {
    cursor.setStick(btn);
  });

  btn.addEventListener('mouseleave', () => {
    cursor.removeStick();
  });
});

function moveElement(e, target) {
  Tween.to(target, 0.3, {
    css: {
      left: e.x - target.offsetWidth / 2,
      top: e.y - target.offsetHeight / 2,
    },
  });
}

const serviceList = document.querySelector('.services-list');

if (serviceList) {
  const serviceItems = serviceList.querySelectorAll('.services-list__item');

  const slider = serviceList.querySelector('.services-list__slider');

  if (slider) {
    const swiper = new Swiper(slider, {
      direction: 'vertical',
      speed: 500,
    });

    serviceList.addEventListener('mousemove', (e) => {
      moveElement(e, slider);
    });
    serviceList.addEventListener('mouseenter', () => {
      slider.classList.add('is-show');
    });
    serviceList.addEventListener('mouseleave', () => {
      slider.classList.remove('is-show');
    });

    serviceItems.forEach((item, idx) => {
      item.addEventListener('mouseenter', () => {
        swiper.slideTo(idx);
      });
    });
  }
}
